const imgbg={
    bg1:require("./img/BG-1.jpg"),
    bg2:require('./img/BG-2.jpg')
}

export default imgbg